'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @fileOverview spaui-decorate kirkzheng
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author kirkzheng
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @time Thu Jul 05 2018 11:17:16 GMT+0800 (CST)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module spaui-decorate
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * import Decorate from '@tencent/spaui-decorate';
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * const component = new Decorate(Component);
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * component.setProps({});
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// 添加一个div到body上
var genContainerInBody = function genContainerInBody(id) {
    var body = document.getElementsByTagName('body')[0];
    var div = document.createElement('div');

    div.className = 'spaui-decorate';
    div.id = id;
    body.appendChild(div);

    return div;
};

// 用于变更组件参数的容器

var DecorateContainer = function (_PureComponent) {
    _inherits(DecorateContainer, _PureComponent);

    function DecorateContainer(props) {
        _classCallCheck(this, DecorateContainer);

        var _this = _possibleConstructorReturn(this, (DecorateContainer.__proto__ || Object.getPrototypeOf(DecorateContainer)).call(this, props));

        _this.state = {
            _decorate_show_component: false // 是否展示组件
        };
        return _this;
    }

    _createClass(DecorateContainer, [{
        key: 'render',
        value: function render() {
            var Component = this.props.Component;

            var _state$_decorate_show = this.state._decorate_show_component,
                _decorate_show_component = _state$_decorate_show === undefined ? true : _state$_decorate_show;

            var result = null;

            if (_decorate_show_component && typeof Component !== 'undefined' && Component) {
                result = _react2.default.createElement(Component, _extends({}, this.state, {
                    _decorate_show_component: ''
                }));
            }

            return result;
        }
    }]);

    return DecorateContainer;
}(_react.PureComponent);

// 计数id


var idCount = 0;

var Decorate = function () {
    function Decorate() {
        var _this2 = this;

        var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, Decorate);

        this.Component = Component;
        this.id = 'spaui-decorate-' + idCount++;
        this.timeout = null;

        // 如果有指定container就用对应的的结构
        this.componentContainer = container || genContainerInBody(this.id);

        // 初始化的时候就加上对应的结构
        this.instance = (0, _reactDom.render)(_react2.default.createElement(DecorateContainer, {
            Component: Component,
            ref: function ref(el) {
                return _this2.container = el;
            }
        }), this.componentContainer);
    }

    _createClass(Decorate, [{
        key: 'setProps',
        value: function setProps() {
            var _this3 = this;

            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var callback = arguments[1];

            var triggerContainterChange = function triggerContainterChange() {
                // 如果已经声明好了，就重新设置下state
                if (_this3.container) {
                    _this3.container.setState(_extends({
                        _decorate_show_component: true
                    }, props), callback);
                }
            };

            if (this.container) {
                triggerContainterChange();
            } else {
                // 有可能一声明就直接调用了，但是this.instance还没有声明好，所以这里稍微延迟下
                clearTimeout(this.timeout);
                this.timeout = setTimeout(function () {
                    triggerContainterChange();
                }, 50);
            }
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            var _this4 = this;

            var Component = this.Component || null;
            // 清空容器与结构
            var clearContainer = function clearContainer() {
                var $id = document.getElementById(_this4.id);

                // 组件清空
                if (_this4.container) {
                    _this4.container.setState({
                        _decorate_show_component: false
                    });
                    _this4.container = null;
                    _this4.instance = null;

                    if (typeof _reactDom.unmountComponentAtNode !== 'undefined') {
                        (0, _reactDom.unmountComponentAtNode)(_this4.componentContainer);
                    }

                    _this4.componentContainer = null;
                }

                // 组件结构清空
                if ($id && $id.parentNode) {
                    $id.parentNode.removeChild($id);
                }
            };

            // 根据对应组件特殊处理下
            if (Component && Component.componentName && Component.componentName.indexOf('spaui-dialog') > -1) {
                this.setProps({
                    show: false
                }, function () {
                    clearContainer();
                });
            } else {
                clearContainer();
            }
        }
    }, {
        key: 'destory',
        value: function destory() {
            this.destroy();
        }
    }]);

    return Decorate;
}();

exports.default = Decorate;